import { render } from "./CouponStatusSelect.vue?vue&type=template&id=5391a89c&scoped=true"
import script from "./CouponStatusSelect.vue?vue&type=script&lang=js"
export * from "./CouponStatusSelect.vue?vue&type=script&lang=js"

import "./CouponStatusSelect.vue?vue&type=style&index=0&id=5391a89c&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5391a89c"]])

export default __exports__